export const downloadBlob = (blob: Blob, fileName: string) => {
  let url: string | undefined, link: HTMLAnchorElement | undefined;
  try {
    url = window.URL.createObjectURL(blob);
    link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  } finally {
    link?.parentNode?.removeChild(link);
    url && window.URL.revokeObjectURL(url);
  }
};
